import { login, getUserInfo } from '@/api/login'
import {simulationLogin} from "@/api/user";
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
import defaultAvatar from '@/assets/avatar.png'

const state = {
    token: getToken(),
    user: {},
    roles: [],
    // 第一次加载菜单时用到
    loadMenus: false
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_USER: (state, user) => {
        state.user = user
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
    SET_LOAD_MENUS: (state, loadMenus) => {
        state.loadMenus = loadMenus
    }
}

const actions = {
  Login({ commit }, userInfo) {
        const rememberMe = userInfo.rememberMe
        return new Promise((resolve, reject) => {
            login(userInfo).then(response => {
                const data = response.data
                const { token } = data
                    // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
                commit('SET_LOAD_MENUS', true)
                setToken(token, rememberMe)
                commit('SET_TOKEN', token)
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },
    simulationLogin({ commit }, id) {
        return new Promise((resolve, reject) => {
            simulationLogin(id).then(response => {
                const data = response.data
                const { token } = data
                    // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
                commit('SET_LOAD_MENUS', true)
                setToken(token, false)
                commit('SET_TOKEN', token)
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // 获取用户信息
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(response => {
          const data = response.data
          setUserInfo(data, commit)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    Logout({ commit }) {
        localStorage.removeItem('sonsMenu')
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            commit('SET_USER', {})
            removeToken()
            resetRouter()
            resolve()
        })
    },

    // remove token
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            removeToken()
            resolve()
        })
    },
    updateLoadMenus({ commit }) {
        return new Promise(resolve => {
            commit('SET_LOAD_MENUS', false)
            resolve()
        })
    }
}

export const setUserInfo = (data, commit) => {
    // 如果没有任何权限，则赋予一个默认的权限，避免请求死循环
    if (!data.roles || data.roles.length === 0) {
        commit('SET_ROLES', ['ROLE_SYSTEM_DEFAULT'])
    } else {
        commit('SET_ROLES', data.roles)
    }
    if (!data.avatar) {
      data.avatar = defaultAvatar
    }
    commit('SET_USER', data)
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
